export const BlueDonutSvg = () => (
  <svg
    width="236"
    height="162"
    viewBox="0 0 236 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 162C62.0907 162 80 144.091 80 122C80 99.9093 62.0907 82 40 82C17.9093 82 -1.6499e-06 99.9093 -3.77729e-06 122C-5.90468e-06 144.091 17.9093 162 40 162ZM40 108.667C47.36 108.667 53.3333 114.64 53.3333 122C53.3333 129.36 47.36 135.333 40 135.333C32.64 135.333 26.6667 129.36 26.6667 122C26.6667 114.64 32.64 108.667 40 108.667Z"
      fill="#1E47A9"
    />
    <mask
      id="mask0_2945_17454"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="76"
      y="0"
      width="160"
      height="160"
    >
      <rect x="76" width="160" height="160" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2945_17454)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M397.111 3.82921e-06L290.074 2.55281e-06C290.074 29.4552 266.113 53.3333 236.556 53.3333C206.998 53.3333 183.037 29.4552 183.037 1.2764e-06L76 0C76 88.3655 147.883 160 236.556 160C325.228 160 397.111 88.3655 397.111 3.82921e-06Z"
        fill="#E60278"
      />
    </g>
  </svg>
);
